<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hidden="$emit('hidden')"
  >
    <div class="p-1 relative">
      <b-button
        variant="link"
        class="close-button"
        @click="$bvModal.hide(id)"
      >
        <feather-icon
          icon="XIcon"
          size="20"
        />
      </b-button>
      <div class="mb-2 text-center">
        <h2 class="font-bold text-black text-2xl mb-1">
          Detail Penolakan
        </h2>
        <p class="text-secondary">
          Silahkan ajukan pendaftaran ulang untuk bisa menggunakan Komads Whitelisted
        </p>
      </div>
      <h5 class="font-weight-bold text-black text-base">
        Catatan
      </h5>
      <div class="border rounded-lg p-1 mb-2 text-left min-h-32">
        <p class="mb-0 text-base break-words">
          {{ modal.description }}
        </p>
      </div>
      <b-button
        variant="primary"
        block
        @click="$emit('on-confirm')"
      >
        Ajukan Ulang
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-pendaftaran-ditolak',
    },
    modal: {
      type: Object,
      default: () => ({
        description: '',
        platform: '',
        account_request_id: null,
        ad_account_type: '',
      }),
    },
  },
}
</script>

<style scoped>
.text-black {
  color: #333333;
}

.close-button {
  padding: 0 !important;
  position: absolute !important;
  top: 1rem;
  right: 1rem;
  color: #292D32 !important;
}
</style>
